import { render, staticRenderFns } from "./orderCenter.vue?vue&type=template&id=685d6076&scoped=true"
import script from "./orderCenter.vue?vue&type=script&lang=js"
export * from "./orderCenter.vue?vue&type=script&lang=js"
import style0 from "./orderCenter.vue?vue&type=style&index=0&id=685d6076&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "685d6076",
  null
  
)

export default component.exports